import React from "react";
import { colors } from "constants/colors";
import { useMemo } from "react";
import { memo } from "react";

const ColorButton = ({ title, colorIndex }) => {
  const colorNo = useMemo(() => {
    return colorIndex > 8 || !colorIndex
      ? Math.floor(Math.random() * 9)
      : colorIndex;
  }, [colorIndex]);

  return (
    <button
      className={`px-3 sm:px-4 md:px-6 py-1 sm:py-2 md:py-3 rounded-full text-[12px] sm:text-sm font-medium ${colors[colorNo]?.bgColor} ${colors[colorNo]?.textColor} hover:shadow-lg`}
    >
      {title}
    </button>
  );
};

export const ColorContainer = memo(({ title, colorIndex }) => {
  const colorNo = useMemo(() => {
    return colorIndex > 8 || !colorIndex
      ? Math.floor(Math.random() * 9)
      : colorIndex;
  }, [colorIndex]);

  return (
    <span
      className={`px-3 sm:px-4 py-1 md:py-2 rounded-full text-[12px] sm:text-sm font-medium ${colors[colorNo]?.bgColor} ${colors[colorNo]?.textColor} whitespace-nowrap hover:shadow-lg`}
    >
      {title.length > 12 ? title.slice(0, 12) + ".." : title}
    </span>
  );
});

export default memo(ColorButton);
